// Constants of the admin console reference (design admin-taskcoolV1 logic: colours, labels, navigation, titles,
// notification events, message templates). Sample data of the reference lives only in frontend/src/dev/demoAdmin.ts.

export const AV = ['#5b8def', '#d98b5f', '#4caf7d', '#b06fd6', '#e0a03a', '#e06c75', '#3fb5b0', '#8a8b91'];
export const GREEN = 'oklch(0.74 0.13 155)', AMBER = 'oklch(0.8 0.12 75)', RED = 'oklch(0.75 0.13 25)', VIOLET = 'oklch(0.75 0.12 300)';
export const MUTED = '#76777d';
export const soft = (c: string): string => 'color-mix(in oklch, ' + c + ' 16%, transparent)';

/** Reference ROLE labels; finance/viewer are server roles the reference does not show (same wording style). */
export const ROLE: Record<string, string> = { super: 'مدیر کل', admin: 'ادمین', support: 'پشتیبان', member: 'کاربر', finance: 'مالی', viewer: 'ناظر' };
export const STATUS: Record<string, [string, string]> = { active: ['فعال', GREEN], invited: ['دعوت‌شده', AMBER], suspended: ['مسدود', RED] };
export const AUDIT_T: Record<string, [string, string]> = { auth: ['ورود', AMBER], user: ['کاربر', '#7ea6f4'], project: ['پروژه', GREEN], share: ['اشتراک', VIOLET], setting: ['تنظیمات', '#c9cacf'] };
export const CTYPE: Record<string, [string, string]> = { added: ['جدید', GREEN], improved: ['بهبود', '#7ea6f4'], fixed: ['رفع اشکال', AMBER] };

/** Label of a private project/item the staff may not see (privacy rule: no private project names for staff). */
export const PRIVATE = 'پروژه خصوصی';

/** Permission matrix rows (reference PERMS minus impersonation, which TaskCool does not offer) → server permission.
 *  Columns: مدیر کل، ادمین، پشتیبان (server roles superadmin, admin, support). */
export const PERMS: Array<[string, string]> = [
  ['دیدن داشبورد و آمار', 'viewReports'], ['مدیریت کاربران و نقش‌ها', 'manageUsers'],
  ['حذف پروژه و انتقال مالکیت', 'manageProjects'], ['انتشار تغییرات نسخه', 'manageReleases'], ['تغییر تنظیمات سیستم', 'editSettings'],
];
/** Default role → matrix permissions (StaffRole defaults); the brand's `role_permissions` setting overrides them. */
export const ROLE_PERMS: Record<'superadmin' | 'admin' | 'support', string[]> = {
  superadmin: ['viewReports', 'manageUsers', 'manageProjects', 'manageReleases', 'editSettings'],
  admin: ['viewReports', 'manageUsers', 'manageProjects', 'manageReleases', 'editSettings'],
  support: ['manageUsers', 'manageProjects'],
};

export const NAV_MAIN: Array<[string, string, string]> = [
  ['overview', 'نمای کلی', 'M5 20v-8M12 20V5M19 20v-5'],
  ['users', 'کاربران', 'M16 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1M9 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M22 19v-1a4 4 0 0 0-3-3.9M16 4.1a3 3 0 0 1 0 5.8'],
  ['projects', 'پروژه‌ها', 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'],
  ['sharing', 'اشتراک و دعوت', 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1'],
];
export const NAV_SYS: Array<[string, string, string]> = [
  ['audit', 'گزارش فعالیت', 'M3 12a9 9 0 1 0 3-6.7M3 4v4h4M12 8v4l3 2'],
  ['changelog', 'تغییرات نسخه', 'M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5z'],
  ['trash', 'سطل زباله', 'M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3'],
  ['backups', 'پشتیبان‌گیری', 'M4 6a8 3 0 1 0 16 0a8 3 0 1 0-16 0M4 6v6a8 3 0 0 0 16 0V6M4 12v6a8 3 0 0 0 16 0v-6'],
  ['notif', 'اعلان، ایمیل، پیامک', 'M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 21h4'],
  ['settings', 'تنظیمات', 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M16 4v4M10 10v4M18 16v4'],
];
export const TITLES: Record<string, [string, string]> = {
  overview: ['نمای کلی', 'وضعیت تسکول در یک نگاه'], users: ['کاربران', 'حساب‌ها، نقش‌ها و وضعیت دسترسی'],
  projects: ['پروژه‌ها', 'همه پروژه‌های ساخته‌شده در تسکول'], sharing: ['اشتراک و دعوت', 'لینک‌های عمومی و دعوت‌های باز'],
  audit: ['گزارش فعالیت', 'هر کاری که ادمین‌ها و کاربران انجام داده‌اند'], changelog: ['تغییرات نسخه', 'متن پنجره «What’s new» که Claude خودکار می‌نویسد'],
  trash: ['سطل زباله', 'پروژه‌ها، لیست‌ها، تسک‌ها و فایل‌های حذف‌شده'], notif: ['اعلان، ایمیل و پیامک', 'چه چیزی، از چه راهی و با چه متنی به کاربران برسد'], settings: ['تنظیمات', 'تنظیمات کلی سیستم'],
  backups: ['پشتیبان‌گیری', 'نسخه‌های پشتیبان همه اطلاعات؛ دانلود و بازگردانی'],
};
/** Sidebar items that need a permission of the signed-in staff member (others: the server answers per call). */
export const NAV_PERM: Record<string, string> = { backups: 'manageBackups' };

export const CH: Array<[string, string, string]> = [
  ['app', 'داخل اپ', 'M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 21h4'],
  ['email', 'ایمیل', 'M3 6h18v12H3zM3 7l9 6 9-6'],
  ['sms', 'پیامک', 'M7 3h10a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM11 18h2'],
];
/** Reference EVENTS with the channels TaskCool actually sends today (app, email, sms); 0 = not sent. */
export const EVENTS: Array<[string, string, string, number[]]> = [
  ['comment', 'کامنت جدید', 'روی تسک‌های کاربر یا تسک‌هایی که در آن کامنت گذاشته', [0, 0, 0]],
  ['mention', 'منشن', 'وقتی با @ از کاربر نام برده می‌شود', [1, 1, 0]],
  ['assign', 'تسک جدید برای کاربر', 'وقتی تسکی به کاربر سپرده می‌شود', [0, 0, 0]],
  ['invite', 'دعوت به پروژه', 'دعوت از طرف اعضای دیگر', [1, 1, 0]],
  ['deadline', 'یادآوری ددلاین', 'قبل از موعد تسک', [1, 1, 0]],
  ['overdue', 'تسک عقب‌افتاده', 'روز بعد از گذشتن موعد', [0, 0, 0]],
  ['digest', 'خلاصه هفتگی', 'تسک‌های باز و انجام‌شده هفته', [0, 0, 0]],
  ['newdevice', 'ورود از دستگاه جدید', 'هشدار امنیتی', [0, 0, 0]],
  ['otp', 'کد ورود و بازیابی رمز', 'اجباری', [0, 0, 0]],
];
export const TPL_DEFAULT: Record<string, [string, string]> = {
  'otp.sms': ['', 'کد ورود شما به تسکول: {code}\nاین کد تا ۲ دقیقه معتبر است.'],
  'otp.email': ['کد ورود به تسکول', 'سلام {name}،\nکد ورود شما {code} است. اگر شما درخواست نداده‌اید این ایمیل را نادیده بگیرید.'],
  'deadline.sms': ['', '{name} عزیز، موعد «{task}» در پروژه {project} فردا است.\n{link}'],
  'deadline.email': ['یادآوری: «{task}» فردا موعد دارد', 'سلام {name}،\nموعد تسک «{task}» در پروژه {project} فردا است.\n{link}'],
  'deadline.app': ['', 'موعد «{task}» فردا است'],
  'invite.sms': ['', '{actor} شما را به پروژه {project} در تسکول دعوت کرد.\n{link}'],
  'invite.email': ['{actor} شما را به {project} دعوت کرد', 'سلام،\n{actor} شما را به پروژه {project} در تسکول دعوت کرده است.\n{link}'],
  'invite.app': ['', '{actor} شما را به {project} دعوت کرد'],
  'mention.email': ['{actor} از شما نام برد', '{actor} در تسک «{task}» از شما نام برد.\n{link}'],
  'mention.app': ['', '{actor} در «{task}» از شما نام برد'],
  'comment.email': ['کامنت جدید روی «{task}»', '{actor} روی تسک «{task}» کامنت گذاشت.\n{link}'],
  'comment.app': ['', '{actor} روی «{task}» کامنت گذاشت'],
  'newdevice.sms': ['', 'ورود جدید به حساب تسکول شما از {device}. اگر شما نبودید رمز را عوض کنید.'],
  'newdevice.email': ['ورود جدید به حساب شما', 'سلام {name}،\nورودی از {device} ثبت شد. اگر شما نبودید رمز عبور را تغییر دهید.\n{link}'],
  'newdevice.app': ['', 'ورود جدید از {device}'],
};
/** Preview sample values of the template editor (reference SAMPLE; illustrative text, not user data). */
export const SAMPLE: Record<string, string> = { name: 'سارا', code: '۴۸۲۱۹۳', task: 'طراحی منو', project: 'Coffee Shop Launch', actor: 'الکس مرادی', link: 'taskcool.app/t/8k2', device: 'Chrome / Windows' };
export const TPL_EVENTS = ['otp', 'deadline', 'invite', 'mention', 'comment', 'newdevice'];

/** Admin console changelog (reference ADMIN_LOG V1, worded to what this release actually ships). */
export const ADMIN_LOG: Array<{ v: number; date: string; items: Array<[string, string]> }> = [
  { v: 1, date: '۱۶ مهر ۱۴۰۵', items: [
    ['added', 'نمای کلی: آمار کاربران و تسک‌ها، نمودار فعالیت، سلامت سیستم، پروژه‌های پرکار و آخرین رویدادها'],
    ['added', 'مدیریت کاربران: فیلتر، جستجو، عملیات گروهی و پنل جزئیات کاربر (نقش، ورودهای اخیر، خروج از همه دستگاه‌ها، مسدودسازی)'],
    ['added', 'دعوت کاربر جدید با ایمیل و نقش'],
    ['added', 'پروژه‌ها با مالک، اعضا، پیشرفت، لینک عمومی و حجم فایل‌ها'],
    ['added', 'اشتراک و دعوت: لینک‌های فقط‌خواندنی (فعال/غیرفعال، کپی) و دعوت‌های در انتظار'],
    ['added', 'گزارش فعالیت با فیلتر و خروجی CSV'],
    ['added', 'تغییرات نسخه: انتشار یا پنهان کردن هر نسخه در پنجره «What’s new»'],
    ['added', 'سطل زباله، اعلان و ایمیل (ارسال ایمیل آزمایشی)، تنظیمات سیستم و نقش‌ها و دسترسی‌ها'],
  ] },
];
export const ADMIN_VERSION = 'V' + ADMIN_LOG[0]!.v;
